var AnalyticsModule = require('../../modules/analytics');
var ActivityModule = require('../../modules/activity');
var CountriesModule = require('../../modules/countries');
var PhoneModule = require('../../modules/phone');
var ZipModule = require('../../modules/zip');
var StateModule = require('../../modules/state');
var AjaxFormModule = require('../../modules/ajaxForm');
var LocalizationModule = require('../../modules/localization');
var WpParseFormModule = require('../../modules/wpParseForm');
var ErrorHandlerModule = require('../../modules/errorHandler');
var LoadSaveForm = require('../../modules/loadSaveForm');
var FloatLabel = require('../../modules/floatLabel');
var ModalUserExist = require('../../modules/modals/modalUserExist');

var Page = {
    alias: 'contact',
    selectors: {
        form: '#subscriptionContactForm',
        button: '#subscriptionContactButton',
        periodSelect: 'select#period',
        subscriptionContactSubmit: '#subscriptionContactSubmit',
    },
    options: {
        dataEntered: false,
        sendInit: $('meta[name="send-init"]').attr('content'),
    },
    templates: {
        group1: 'group1'
    },
    formValidator: null,

    init: function () {
        AnalyticsModule.send('step1', false);

        ActivityModule.pageLoad(Page.alias)
        PhoneModule.init()
        ZipModule.init()
        StateModule.init()
        CountriesModule.init()
        LoadSaveForm.init()

        Page.onFormSubmit();
        ModalUserExist.init();

        if ( window.location.search ) {
            WpParseFormModule.init()
        }
        const submitLoadedEvent = $(Page.selectors.subscriptionContactSubmit).data('loaded-event')

        if (submitLoadedEvent) {
            ActivityModule.form(Page.alias, submitLoadedEvent)
        }

        Page.registerOnDataEnterListeners()
        Page.initPeriodsSelect()
        Page.sendAddToCardEvent()

        Page.formValidator = AjaxFormModule.validate(
            $(Page.selectors.form),
            AjaxFormModule.validationRules.subscription.contact,
            LocalizationModule.getTranslationsByKey('form_contact')
        )

        if ($('.cnt-section').length > 0) {
            Page.initNewClassicTemplate()
        }

        Page.initPromoInput();

        $(document).on('click', '.select2', function(e) {
            e.preventDefault();
            let searchField = $('.select2-search__field');
            if (searchField.length > 0) {
                searchField.focus();
            }
        });

        FloatLabel.init();
    },

    registerOnDataEnterListeners: function () {
        $(document).on(CountriesModule.name + ':changed', function (e) {
            if (Page.formValidator) {
                Page.formValidator.resetForm();
                $('.' + AjaxFormModule.validationSuccessClass + ', .' + AjaxFormModule.validationErrorClass, Page.selectors.form)
                    .removeClass(AjaxFormModule.validationSuccessClass)
                    .removeClass(AjaxFormModule.validationErrorClass);
			}
            Page.onDataEnter(e);
        })

        $(document).on('select2:select', '.select2-init', function (e) {
            Page.onDataEnter(e);
        });

        $(Page.selectors.form).find('input, select').on('change, keyup', function (e) {
            Page.onDataEnter(e);
        })
    },

    onDataEnter: function (e) {
        if (Page.options.dataEntered === true) {
            return;
        }

        ActivityModule.form(Page.alias, 'data_enter');
        Page.options.dataEntered = true;
    },

    onFormSubmit: function () {
        if ($(Page.selectors.form).length === 0) {
            return;
        }

        $(Page.selectors.subscriptionContactSubmit).on('click', function () {
            $(Page.selectors.form).submit();
        })

        $(Page.selectors.subscriptionContactSubmit).on('touch', function (e) {
            $(Page.selectors.form).submit();
        })

        $(document).on('submit', Page.selectors.form, function (e) {
            e.preventDefault()
    
            Page.initAnalyticExternalId();

            let form = $(this);
            $('button', form).attr('disabled', true).addClass('disabled');

            if($('#phoneInput').length > 0) {
                $('#phoneInput').val($('#phoneInput').val().trim())
            }

            ActivityModule.form(Page.alias, 'submit.try')

            if (Page.formValidator.valid()) {
                var submitActivityEvent = $(Page.selectors.subscriptionContactSubmit).data('activity-event')

                if (submitActivityEvent) {
                    ActivityModule.form(Page.alias, submitActivityEvent)
                }

                ActivityModule.form(Page.alias, 'submit')

                AjaxFormModule.submit(form, function (response) {
                    if (response.id) {
                        AnalyticsModule.options.orderId = response.id;
                    }

                    // LoadSaveForm.setCookie('', -1);
                    window.location = response.url;
                }, function (response) {
                    $('button', form).attr('disabled', false).removeClass('disabled');
                    ActivityModule.formErrorResponse(Page.alias, response)
                }, null, false);
            } else {
                $('button', form).attr('disabled', false).removeClass('disabled');
                ActivityModule.form(Page.alias, 'validation_error')
            }
        })
    },

    initPeriodsSelect() {
        const select = $(Page.selectors.periodSelect);
        const contactHeader = $('h3.page_title_small').first();
        const contactBasketPeriodTitle = $('.blue-bottom-period-wrapper .first').first();

        if (select.has() && select.length > 0) {
            const selectParent = select.parent('.form-group');

            if ($('#template').val() !== Page.templates.group1) {
                selectParent.children('label').addClass('hid');
            }

            $(window).on('load', function () {
                const title = select.find(':selected').data('select-title');
                const basketTitle = `<span>${select.find(':selected').data('basket-title')} </span>`;
                const periodTitle = select.find(':selected').data('period-title');

                contactHeader.html(title);
                contactBasketPeriodTitle.html(basketTitle + periodTitle);
            })

            $(Page.selectors.periodSelect).on('select2:select', function (e) {
                selectParent.removeClass('has-error')
                let option = $(e.params.data.element);

                let total = option.data('total-price');
                let subTotal = option.data('subtotal-price');
                let shippingTotal = option.data('shipping-price');
                let currencySymbol = option.data('currency-symbol');

                $('#period-title-label, .period-title-label').text($(this).find('option:selected')
                    .attr('data-period-title').replace(/\s\([a-zA-Z]+\)/,''));
                $('#period-title-total-price').text(currencySymbol + total + ".00");
                $('#period-title-subtotal-price').text(currencySymbol + subTotal + ".00");
                $('#period-title-shipping-price').text(currencySymbol + shippingTotal + ".00");

                selectParent.children('label').removeClass('active')
                if (option.val() !== '') {
                    selectParent.children('label').addClass('active')
                }

                contactHeader.html(option.data('select-title'))

                const basketTitle = `<span>${option.data('basket-title')} </span>`
                contactBasketPeriodTitle.html(basketTitle + option.data('period-title'))
            });
        }
    },

    sendAddToCardEvent() {
        $(window).on('load', function() {
            const eventAddToCardUrl = $('meta[name="event-add-to-card-url"]').attr('content');
            if (eventAddToCardUrl === undefined) {
                return;
            }

            $.ajax({
                type: 'POST',
                url: eventAddToCardUrl,
                data: {}
            })
        })
    },

    updateOrCreatePreOrderUser() {
        let postData = {};
        $(Page.selectors.form).serializeArray().forEach(function (item) {
            postData[item.name] = item.value;
        });

        $.ajax({
            type: 'POST',
            url: $('meta[name="app-url"]').attr('content') + '/user/createPreOrderUser',
            data: postData
        })
    },

    initPromoInput() {
        $(document).on('click', '#haveCode', function() {
            if ($('#promo_code').val() !== '') {
                var href = new URL(window.location.href);
                href.searchParams.set('promo', $('#promo_code').val());
                window.location.href = href;
            }
        }).on('click', '.cleanPromo', function() {
            var href = new URL(window.location.href);
            href.searchParams.delete('promo');
            window.location.href = href;
        }).on('input', '#promo_code', function() {
            let promoInput = $(this);
            $('.promo-applied-btn, .promo-clean-btn', promoInput.parent()).addClass('promo-hide');
            if (promoInput.val()) {
                $('.promo-apply-btn', promoInput.parent()).addClass('promo-show');
                $('.promo-apply-btn', promoInput.parent()).removeClass('promo-hide');
                $('.promo-apply-icon', promoInput.parent()).addClass('promo-hide');
                $('.promo-apply-icon', promoInput.parent()).removeClass('promo-show');
                promoInput.parent().addClass('promo-filled');
            } else {
                $('.promo-apply-btn', promoInput.parent()).addClass('promo-hide');
                $('.promo-apply-btn', promoInput.parent()).removeClass('promo-show');
                $('.promo-apply-icon', promoInput.parent()).addClass('promo-show');
                $('.promo-apply-icon', promoInput.parent()).removeClass('promo-hide');
                promoInput.parent().removeClass('promo-filled');
            }
        });
    },

    initNewClassicTemplate() {
        let disabledStepClass = 'step-disabled';
        $(document).on('click', '.cnt-step-button', function() {
            let currentStepWrapper = $(this).closest('.cnt-form-step');

            let validStep = true;
            $('input, select', currentStepWrapper).each(function(i, input){
                validStep = Page.formValidator.element(input) && validStep;
            });
            if (!validStep) {
                return;
            }

            Page.updateOrCreatePreOrderUser();

            let currentStep = currentStepWrapper.data('step');
            currentStepWrapper.removeClass(disabledStepClass).removeClass('active').next().addClass('active');

            $('.cnt-form-step').each(function(index, step) {
                let stepElement = $(step);
                if (stepElement.data('step') > currentStep) {
                    stepElement.addClass(disabledStepClass);
                } else if (stepElement.data('step') < currentStep) {
                    stepElement.removeClass(disabledStepClass);
                }
            });
        }).on('click', '.cnt-form-step:not(.' + disabledStepClass + ',.active) .cnt-form-step-header', function() {
            $('.cnt-form-step').removeClass('active');

            let currentStepWrapper = $(this).closest('.cnt-form-step');
            let currentStep = currentStepWrapper.data('step');

            currentStepWrapper.addClass('active').addClass(disabledStepClass);

            $('.cnt-form-step').each(function(index, step) {
                let stepElement = $(step);
                if (stepElement.data('step') > currentStep) {
                    stepElement.addClass(disabledStepClass);
                } else if (stepElement.data('step') < currentStep) {
                    stepElement.removeClass(disabledStepClass);
                }
            });
        });
    },

    initAnalyticExternalId() {
        let input = $('#analytic_external_id');
        if (
            input.length > 0 && 
            typeof LH_Klaviyo === 'object' &&
            typeof LH_Klaviyo.get_external_id_klaviyo === 'function'
        ) {
            let analyticExternalId = LH_Klaviyo.get_external_id_klaviyo();
            input.val(analyticExternalId);
        }
    },
}

Page.init();
